export default "__VITE_ASSET__DF5baDWD__"